'use client';
import React, { useMemo } from 'react';
import { UpsellBarProps } from './types';
import classNames from 'classnames';
import { FREE_SHIPPING_THRESHOLD } from '../../utils/discountLogic';
import { formatMedusaPrice } from '../../utils/formatMedusaPrice';

const UpsellBar = ({ amount, inFloatingCta }: UpsellBarProps) => {
  const { thresholdText, shippingPercentage } = useMemo(() => {
    if (amount < FREE_SHIPPING_THRESHOLD) {
      const remainingAmount = FREE_SHIPPING_THRESHOLD - amount;

      return {
        thresholdText: `Besteed nog ${formatMedusaPrice(remainingAmount)} en krijg <b>gratis verzending t.w.v. € 15,-</b>`,
        shippingPercentage: 100 - (remainingAmount / FREE_SHIPPING_THRESHOLD) * 100,
      };
    }

    return {
      amountToThreshold: null,
      thresholdText: `Je krijgt <b>gratis verzending</b>!`,
      shippingPercentage: 100,
    };
  }, [amount]);

  return (
    <div
      className={classNames(
        `pt-[10px] py-[20px] pb-[40px] after:pointer-events-none after:absolute after:bg-grey/10 after:bottom-0 after:top-0 relative w-full h-[88px]"`,
        {
          'mb-[-45px] lg:after:-left-10 after:-left-5 after:w-[calc(100%+40px)] lg:after:w-[calc(100%+80px)]':
            !inFloatingCta,
        },
        { 'mb-[-25px] after:py-5 after:-left-5 after:w-[calc(100%+40px)]': !!inFloatingCta }
      )}
    >
      <p
        className="text-dark text-[12px] leading-[21px] text-center"
        dangerouslySetInnerHTML={{ __html: thresholdText }}
      />
      <div className="mt-2 flex gap-2">
        <div className={'z-10 relative w-full h-[8px]'}>
          <div className="absolute w-full h-[8px] bg-white rounded-10"></div>
          <div
            style={{ width: shippingPercentage !== null ? `${shippingPercentage}%` : '100%' }}
            className={`transition-width duration-300 left-0 absolute h-[8px] bg-green-brand rounded-10`}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default UpsellBar;
